export const UPDATE_DATA = 'app/EditSessionPage/ParticipantReport/UPDATE';
export const UPDATE_VARIABLE =
  'app/EditSessionPage/ParticipantReport/UPDATE_VARIABLE';
